module.exports = __webpack_public_path__ + "static/media/instaIcon.228a46d8.png";